import fetch from "auth/FetchInterceptor";

const CategoryService = {};

CategoryService.getCategories = function (languageId) {
  return fetch({
    url: "/categories/",
    method: "get",
    headers: {
      "Language-Id": languageId, // Pass the language ID in headers
    },
  });
};

CategoryService.getCategory = function (categoryId, languageId) {
  return fetch({
    url: `/categories/${categoryId}/`,
    method: "get",
    headers: {
      "Language-Id": languageId, // Pass the language ID in headers
    },
  });
};

CategoryService.createCategories = function (params) {
  return fetch({
    url: `/categories/`,
    method: "post",
    data: params,
  });
};
CategoryService.updateCategories = function (categoryId, data) {
  return fetch({
    url: `/categories/${categoryId}/`,
    method: "put",
    data: data,
  });
};

// Add a new method to delete a category by its ID
CategoryService.deleteCategory = function (categoryId) {
  return fetch({
    url: `/categories/${categoryId}/`, // Assuming the API uses this pattern
    method: "delete",
  });
};

export default CategoryService;
